import React from 'react';
import '../styles/_popup.scss';
import Spinner from './Spinner';

const Popup = ({ showPopup, hideSubmit, setShowPopup, title, buttonTitle, buttonAction, error, loading, children, backButton, backButtonAction }) => {
  return (
    <div className={`popup ${showPopup ? 'show' : 'hide'} ${title === 'Change Password' ? 'password' : ''}`}>
      <div className="overlay"></div>
      <div className="popup-block">
        <div className="popup-top">
          <h2>{title}</h2>
          <img onClick={() => setShowPopup(false)} src="../icon_x_ko.png" alt="close"/>
        </div>
        {children}
        {error !== '' &&
          <p className="error popup-description">{error}</p>
        }
        {backButton &&
          <div className="btn primary addSpace" onClick={() => backButtonAction()}>
            Go Back
          </div>
        }
        {!hideSubmit &&
          <div className="btn primary" onClick={() => buttonAction()}>
            { loading ? <Spinner /> : buttonTitle }
          </div>
        }
       
      </div>
    </div>
  )
}

export default Popup;